import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Container component="main" maxWidth="md">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          gap: 2
        }}
      >
        <ErrorOutlineIcon sx={{ fontSize: 100, color: 'text.secondary', mb: 2 }} />
        
        <Typography variant="h1" component="h1" fontWeight="bold" color="primary">
          404
        </Typography>
        
        <Typography variant="h4" component="h2">
          {t('NotFound.title', 'Page Not Found')}
        </Typography>
        
        <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 500 }}>
          {t('NotFound.description', 'Sorry, the page you are looking for does not exist or has been moved.')}
        </Typography>

        <Button
          variant="contained"
          size="large"
          onClick={() => navigate('/')}
          sx={{ mt: 3, px: 5, borderRadius: 2 }}
        >
          {t('NotFound.backHome', 'Back to Home')}
        </Button>
      </Box>
    </Container>
  );
};

export default NotFoundPage;